// eslint-disable-next-line import/prefer-default-export
export const taskInputSearchResults = [
  { type: "INPUT_FOUND", label: "Input", class: "border-purple-800 text-purple-800" },
  { type: "OUTPUT_FOUND", label: "Output", class: "border-red-800 text-red-800" },
  { type: "NOT_INPUT_OR_OUTPUT", label: "Not input or output", class: "border-yellow-800 text-yellow-800" },
  { type: "PROD_TEMPLATE_OLD", label: "Prod. Template (Old)", class: "border-red-800 text-red-800" },
  {
    type: "PROD_TEMPLATE_GROUPS",
    label: "Prod. Template (Groups)",
    class: "border-purple-800 text-purple-800",
  },
  { type: "DASHBOARD_OLD", label: "Dashboard (Old)", class: "border-red-800 text-red-800" },
  { type: "DASHBOARD", label: "Dashboard", class: "border-purple-800 text-purple-800" },
  { type: "NOT_FOUND", label: "Not Found", class: "" },
];
